/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.2.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * User clicked "Skip for now" on the desktop (authority) QR code screen,
 * leaving the pairing flow for account settings.
 *
 * Generated from `dtm_desktop.qr_skip`.
 */
export const qrSkip = new EventMetricType(
  {
    category: 'dtm_desktop',
    name: 'qr_skip',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * User viewed the pairing interrupted screen on the desktop (authority)
 * device. One route serves both the timed-out and the canceled state, so the
 * state is in 'reason' rather than being inferable from the URL.
 *
 * Generated from `dtm_desktop.timeout_view`.
 */
export const timeoutView = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'dtm_desktop',
    name: 'timeout_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);
